export default {
    topics: [
        {
            title: 'Basic classes',
            href: 'c-File.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e4860',
            next: 'tocId-d66e4860',
        },
        {
            title: 'Network',
            href: 'c-FTP.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e5296',
            next: 'tocId-d66e5296',
        },
        {
            title: 'Database',
            href: 'c-DBEngine.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e5618',
            next: 'tocId-d66e5618',
        },
        {
            title: 'Application',
            href: 'c-Application.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e5780',
            next: 'tocId-d66e5780',
        },
        {
            title: 'Schema',
            href: 'c-Schema.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e5974',
            next: 'tocId-d66e5974',
        },
        {
            title: 'Document',
            href: 'c-Entity.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e6716',
            next: 'tocId-d66e6716',
        },
        {
            title: 'Workflow',
            href: 'c-WorkflowTask.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e6773',
            next: 'tocId-d66e6773',
        },
        {
            title: 'XML',
            href: 'c-DOMDocument.html',
            menu: { hasChildren: false },
            tocID: 'tocId-d66e6862',
            next: 'tocId-d66e6862',
        },
    ],
};

